import { ListItem, Section } from '@/components';
import { UnderlyingYieldBearingAssetInterface } from '@/interfaces';
import { LABELS } from '@/utils/strings';
import React, { FC } from 'react';
import { TiChartPie } from 'react-icons/ti';
interface Props {
  underlyingYieldBearingAsset: UnderlyingYieldBearingAssetInterface;
}
const ShareOfCompositionIcon = TiChartPie as React.ComponentType<any>;
const ShareOfCompositionSection: FC<Props> = ({
  underlyingYieldBearingAsset,
}) => {
  const compositionPercentage = underlyingYieldBearingAsset.composition
    ? `${(underlyingYieldBearingAsset.composition * 100).toFixed(2)}%`
    : null;
  return (
    <Section
      body={
        <ListItem
          leftIcon={<ShareOfCompositionIcon className="text-secondary" />}
          leftIconWidth={33}
          leftIconHeight={33}
          mainText={
            LABELS.YIELD_BEARING_ASSET_DETAIL_CARD
              .SHARE_OF_COMPOSITION_METRIC_LABEL
          }
          mainTextSize={'caption'}
          mainTextColor={'primary'}
          subText={compositionPercentage}
          subTextSize={'body'}
        />
      }
    />
  );
};
export default ShareOfCompositionSection;
